import type { Monaco } from "@monaco-editor/react";
import type { IRange, Position, editor } from "@promptlayer/ui/monaco-types";

export const getCompletionInsertRange = (model: editor.ITextModel, position: Position): IRange => {
  const word = model.getWordUntilPosition(position);
  return {
    startLineNumber: position.lineNumber,
    endLineNumber: position.lineNumber,
    startColumn: word.startColumn,
    endColumn: word.endColumn,
  };
};

export const setCodeBlockJavaScriptCompilerOptions = (monaco: Monaco) => {
  const ts = monaco.languages.typescript as {
    javascriptDefaults: {
      setCompilerOptions: (options: Record<string, unknown>) => void;
      getCompilerOptions: () => Record<string, unknown>;
    };
  };
  ts.javascriptDefaults.setCompilerOptions({
    ...ts.javascriptDefaults.getCompilerOptions(),
    noLib: true,
    allowNonTsExtensions: true,
    checkJs: true,
    strict: true,
  });
};
